import React, { useEffect, useState } from "react";
import { HashRouter as Router } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { DashboardRouter } from "@/app/modules/dashboard";
import AuthenticationRouter from "@/app/modules/auth";
import RecoverRouter from "@/app/modules/recover";
import CadastroRouter from "@/app/modules/register";
import Error404Page from "./core/layouts/errors/Error404Page";
import Storage from "./core/util/Storage";
import { ReclamarRouter } from "./modules/reclamar";
import { PerfilRouter } from "./modules/profile";
import { AboutRouter } from "./modules/about";
import { EmpresaRouter } from "./modules/empresa";
import { AdminDashboardRouter } from "./modules/administrator/dashboard";
import { UsersRouter } from "./modules/administrator/users";
import { CompaniesRouter } from "./modules/administrator/companies";
import { ComplainsRouter } from "./modules/administrator/complains";
import { ServicesRouter } from "./modules/administrator/services";
import { ContatoRouter } from "./modules/contact";
import { WhatsRouter } from "./modules/reclamarWhats";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { PlanosRouter } from "./modules/reclamarPlano";

export default function App() {
  if (!localStorage.getItem("theme")) {
    localStorage.setItem("theme", "light");
  }

  document.body.classList.add("bg-" + Storage.getTheme());

  const auth = getAuth();

  onAuthStateChanged(auth, async (user) => {
    if (user) {
      await user.getIdToken(true); // Forces a token refresh to get the latest claims
      const tokenResult = await user.getIdTokenResult();
      console.log("Admin status:", tokenResult.claims.admin);
    }
  });

  const routes = [
    ReclamarRouter,
    PerfilRouter,
    AuthenticationRouter,
    AboutRouter,
    EmpresaRouter,
    AdminDashboardRouter,
    UsersRouter,
    ComplainsRouter,
    ServicesRouter,
    ContatoRouter,
    RecoverRouter,
    WhatsRouter,
    PlanosRouter,
    CompaniesRouter,
    CadastroRouter,
    DashboardRouter,
    // {
    //   path: "/confirm/:key",
    //   component: ConfirmPage,
    //   onShell: false,
    // },
    {
      path: "*",
      component: PlanosRouter,
      // onShell: false,
    },
  ];

  return <Router>{renderRoutes(routes)}</Router>;
}
